(() => {
  'use strict';

  const initializePetoraHero = () => {
    const heroes = document.querySelectorAll('.petora-hero');

    if (!heroes.length) return;

    const desktopQuery = window.matchMedia('(min-width: 991px)');
    const reducedMotionQuery = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    heroes.forEach((hero) => {
      const image = hero.querySelector('.petora-hero__image');

      hero.classList.add('petora-loaded');

      if (!image) return;

      let ticking = false;

      const resetImage = () => {
        image.style.transform = '';
      };

      const updateParallax = () => {
        ticking = false;

        if (
          !desktopQuery.matches ||
          reducedMotionQuery.matches
        ) {
          resetImage();
          return;
        }

        const heroRect = hero.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        const isVisible =
          heroRect.bottom > 0 &&
          heroRect.top < viewportHeight;

        if (!isVisible) return;

        const heroProgress =
          (viewportHeight - heroRect.top) /
          (viewportHeight + heroRect.height);

        const movement = Math.max(
          -45,
          Math.min(45, (heroProgress - 0.5) * 70)
        );

        image.style.transform =
          `translate3d(0, ${movement}px, 0) scale(1.04)`;
      };

      const requestParallaxUpdate = () => {
        if (ticking) return;

        ticking = true;
        window.requestAnimationFrame(updateParallax);
      };

      window.addEventListener(
        'scroll',
        requestParallaxUpdate,
        { passive: true }
      );

      window.addEventListener(
        'resize',
        requestParallaxUpdate,
        { passive: true }
      );

      if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener(
          'change',
          requestParallaxUpdate
        );

        reducedMotionQuery.addEventListener(
          'change',
          requestParallaxUpdate
        );
      }

      requestParallaxUpdate();
    });
  };

  const initializeSmoothScroll = () => {
    const scrollLinks = document.querySelectorAll(
      '.petora-hero__scroll[href^="#"]'
    );

    scrollLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href');

        if (!targetId || targetId === '#') return;

        const target = document.querySelector(targetId);

        if (!target) return;

        event.preventDefault();

        target.scrollIntoView({
          behavior: window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches
            ? 'auto'
            : 'smooth',
          block: 'start'
        });
      });
    });
  };

  const initializePetora = () => {
    initializePetoraHero();
    initializeSmoothScroll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializePetora,
      { once: true }
    );
  } else {
    initializePetora();
  }

  document.addEventListener(
    'shopify:section:load',
    initializePetora
  );
})();